<template>
  <dx-popup
    :visible.sync="isSignedDocsShown"
    :drag-enabled="false"
    :close-on-outside-click="true"
    :show-title="false"
    :show-close-button="false"
  >
    <div style="height: 100%">
      <dx-scroll-view>
        <b-row class="mb-3">
          <b-col class="mb-10 d-flex flex-row justify-content-end">
            <dx-button
              class="close-text-button"
              :text="$t('Close')"
              icon="ace-icon icon-close"
              @click="isSignedDocsShown = false"
            >
            </dx-button>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col>
            <h2>
              {{ $t('History of changes') }}
            </h2>
          </b-col>
        </b-row>
        <dx-data-grid
          :data-source="signedDocs"
        >
          <dx-column
            :caption="$t('Date')"
            data-field="create_date"
            data-type="date"
          >
          </dx-column>
          <dx-column
            :caption="$t('Status')"
            cell-template="status-cell-template"
          />
          <template #status-cell-template="{ data }">
            <div class="status-cell">
              {{ $t(data.data.for_status.name) }}
            </div>
          </template>
          <dx-column
            :caption="$t('User')"
            data-field="author.username"
          >
          </dx-column>
          <dx-column
            :caption="$t('Download')"
            cell-template="download-cell-template"
          />
          <template #download-cell-template="{ data }">
            <a
              href="#"
              @click.prevent="openSign(data.data)"
            >
              {{ data.data.filename }}
            </a>
          </template>
        </dx-data-grid>
      </dx-scroll-view>
    </div>
  </dx-popup>
</template>

<script>
import { mapState } from 'vuex';

import { DxButton } from 'devextreme-vue';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxPopup } from 'devextreme-vue/popup';

import {
  DxDataGrid,
  DxColumn,
} from 'devextreme-vue/data-grid';

export default {
  name: 'SignedDocsModal',
  components: {
    DxButton,
    DxPopup,
    DxScrollView,
    DxDataGrid,
    DxColumn,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    signedDocs: Array,
  },
  data: () => ({
  }),
  computed: {
    ...mapState(['user']),
    isSignedDocsShown: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    closeButtonOptions() {
      return {
        text: 'Закрыть',
        icon: 'ace-icon icon-close',
        onClick: () => {
          this.isSignedDocsShown = false;
        },
      };
    },
  },
  methods: {
    openSign(data) {
      this.$http({
        url: this.getSignUrl(data),
        method: 'GET',
        responseType: 'blob',
      })
        .then(response => {
          const href = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', data.filename);
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    getSignUrl(file) {
      return `${process.env.VUE_APP_API_URL}/tracking/api/freight_orders/${file.freight_order}/sign/${file.id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .status-cell {
    color: #3C5AC3;
    text-decoration: underline;
  }

    .close-text-button {
    width: fit-content;
    color: #3C5AC3;
    background-color: white;
    box-shadow: none;
    &:hover {
      color: #2347C6;
      background-color: white;
      box-shadow: none;
    }
    &:active,
    &:focus {
      color: #3C5AC3;
      border: 2px solid #3C5AC3;
      background-color: white;
      box-shadow: none;
      transition: all 0.2s;
    }
  }
</style>
